import { useConfigurationSelector } from "@redux/reducers/appConfig";
import { VEHICLE_REGISTRATION_METHOD } from "@shared/constants";
import { getSolJourneyConfigForJourney } from "@shared/v2/lib/getSolJourneyConfigForJourney";

import {
  useBusinessModelSelector,
  useFinanceSimulationSelector,
} from "@redux/reducers/deal";
import { useIsKeyAccount } from "@redux/reducers/auth";

export const useGetAvailableRegistrationMethods = () => {
  const configuration = useConfigurationSelector();
  const businessModel = useBusinessModelSelector();
  const financeSimulation = useFinanceSimulationSelector();

  const { vehicleRegistration } = getSolJourneyConfigForJourney(
    financeSimulation.journey,
    businessModel,
    configuration
  );

  return getMethods(vehicleRegistration);
};

const getMethods = registrationSettings => {
  const { CITROEN, MYSELF } = VEHICLE_REGISTRATION_METHOD;

  const result = [];

  const isKeyAccount = useIsKeyAccount();

  if (registrationSettings) {
    if (registrationSettings.selfRegistration.enabled && !isKeyAccount) {
      result.push({
        ...registrationSettings.selfRegistration,
        method: MYSELF,
      });
    }

    if (registrationSettings.citroenRegistration.enabled) {
      result.push({
        ...registrationSettings.citroenRegistration,
        method: CITROEN,
      });
    }
  }

  return result;
};
